<template>
<div class="phone_capability_box">
    <!-- 标题 -->
    <div class="capability_title">平台開放能力</div>

      <!-- 内容 -->
      <div class="capability">

        <el-carousel :autoplay="false" arrow="always" indicator-position="none" height="90vw">
          <el-carousel-item>
            <!-- 01 -->
            <div class="capability_no1">
              <img src="../../../assets/img/home/icon_capability01.png" alt="">
              <h3>支付産品</h3>
              <p>
                臺易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！
              </p>
              <div class="more">
                了解詳情
              </div>
            </div>
            <!-- 02 -->
            <div class="capability_no1">
              <img src="../../../assets/img/home/icon_capability02.png" alt="">
              <h3>營運工具</h3>
              <p>
                臺易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！
              </p>
              <div class="more">
                了解詳情
              </div>
            </div>

          </el-carousel-item>
          <el-carousel-item>
            <!-- 03 -->
            <div class="capability_no1">
              <img src="../../../assets/img/home/icon_capability03.png" alt="">
              <h3>資金管理</h3>
              <p>
                臺易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！
              </p>
              <div class="more">
                了解詳情
              </div>
            </div>
            <!-- 04 -->
            <div class="capability_no1">
              <img src="../../../assets/img/home/icon_capability04.png" alt="">
              <h3>拓展工具</h3>
              <p>
                臺易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！
              </p>
              <div class="more">
                了解詳情
              </div>
            </div>

          </el-carousel-item>

        </el-carousel>

      </div>
    <!-- 分割线 -->
    <div class="cut_off"></div>
</div>
</template>

<script>
export default {
  name: 'PhoneCapability',
  props: {
  },
  data() {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 標題 */
.capability_title {
  font-size: 8vw;
  margin: 7.2vw 0;
  font-weight: bold;
  color: black;
  text-align: center;
}
.el-carousel__item {
  padding: 0 2vw;
  box-sizing: border-box;
  display: flex;
  color: black;

}
.el-carousel__item >div {
  box-sizing: border-box;
  display: flex;
  /* flex: 1; */
  width: 48%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* border: 1vw solid transparent; */
  border: 1vw solid #000;
}
.el-carousel__item .active {
  border: 1vw solid #000;
}

.el-carousel__item >div+div {
  /* margin-left: 3.3vw; */
  margin-left: 4%;
}
.el-carousel__item img {
  width: 18.7vw;
}
.el-carousel__item >div >h3 {
  box-sizing: border-box;
  font-size: 4.8vw;
  margin: 4vw 0;
}
.el-carousel__item >div >p {
  box-sizing: border-box;
  padding: 0 5vw;
  line-height: 5vw;
  
}
.el-carousel__item .more {
  box-sizing: border-box;
  font-size: 4.8vw;
  font-weight: bold;
  margin: 6vw 0 4vw 0;
  padding-bottom: 2vw;
  border-bottom: 2px solid #000;
}
.cut_off {
  margin-top: 6vw;
  height: 2px;
  background: #e8e8e8;
}

    /* 768px */
@media screen and (min-width:769px){
  /* 显示/隐藏 */
  .phone_capability_box {
    display: none;
  }
}
</style>
